import {
    MainScreen,
    LoginScreen,
    HomeScreen,
    DemographicScreen,
    // LanguageQuestionScreen,
    // AdminScreen
} from '../components/screens';

export const IntroductionRoutes = [
    { path: '/', component: MainScreen, requireSessionID: false, monitorProgress: false },
    { path: '/Login', component: LoginScreen, requireSessionID: false, monitorProgress: true },
    { path: '/Home', component: HomeScreen, requireSessionID: true, monitorProgress: true },
    { path: '/Demographic', component: DemographicScreen, requireSessionID: true, monitorProgress: true },
    // { path: '/Language', component: LanguageQuestionScreen, requireSessionID: true, monitorProgress: true }
    // { path: '/Admin', component: AdminScreen, requireSessionID: false, monitorProgress: true }
];
